import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import './ToolStyles.css';

interface Timezone {
    name: string;
    zone: string;
}

const timezones: Timezone[] = [
    { name: 'UTC (协调世界时)', zone: 'UTC' },
    { name: 'GMT (格林威治时间)', zone: 'GMT' },
    { name: 'EST (美国东部时间)', zone: 'America/New_York' },
    { name: 'CST (美国中部时间)', zone: 'America/Chicago' },
    { name: 'MST (美国山地时间)', zone: 'America/Denver' },
    { name: 'PST (美国太平洋时间)', zone: 'America/Los_Angeles' },
    { name: 'CET (中欧时间)', zone: 'Europe/Paris' },
    { name: 'JST (日本标准时间)', zone: 'Asia/Tokyo' },
    { name: 'CST (中国标准时间)', zone: 'Asia/Shanghai' },
    { name: 'AEST (澳大利亚东部时间)', zone: 'Australia/Sydney' },
    { name: 'IST (印度标准时间)', zone: 'Asia/Kolkata' },
    { name: 'MSK (莫斯科时间)', zone: 'Europe/Moscow' },
];

const TimezoneConverter = () => {
    const [currentTime, setCurrentTime] = useState(new Date());
    const [sourceZone, setSourceZone] = useState('Asia/Shanghai');
    const [targetZone, setTargetZone] = useState('America/New_York');
    const [inputTime, setInputTime] = useState('');

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        const now = new Date();
        const formatted = format(now, "yyyy-MM-dd'T'HH:mm");
        setInputTime(formatted);
    }, []);

    const getConvertedTime = () => {
        if (!inputTime) return '';

        try {
            const date = new Date(inputTime);
            return formatInTimeZone(date, targetZone, 'yyyy-MM-dd HH:mm:ss zzz');
        } catch {
            return '无效时间';
        }
    };

    return (
        <div className="tool-container">
            <div className="current-times">
                <h3>当前时间</h3>
                <div className="time-grid">
                    {timezones.map((tz) => {
                        const timeStr = formatInTimeZone(currentTime, tz.zone, 'HH:mm:ss');
                        return (
                            <div key={tz.zone} className="time-item">
                                <div className="time-zone-name">{tz.name}</div>
                                <div className="time-value">{timeStr}</div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="converter-section">
                <h3>时区转换</h3>

                <div className="input-group">
                    <label className="input-label">源时区</label>
                    <select
                        className="tool-select"
                        value={sourceZone}
                        onChange={(e) => setSourceZone(e.target.value)}
                    >
                        {timezones.map((tz) => (
                            <option key={tz.zone} value={tz.zone}>
                                {tz.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="input-group">
                    <label className="input-label">时间</label>
                    <input
                        type="datetime-local"
                        className="tool-input"
                        value={inputTime}
                        onChange={(e) => setInputTime(e.target.value)}
                    />
                </div>

                <div className="input-group">
                    <label className="input-label">目标时区</label>
                    <select
                        className="tool-select"
                        value={targetZone}
                        onChange={(e) => setTargetZone(e.target.value)}
                    >
                        {timezones.map((tz) => (
                            <option key={tz.zone} value={tz.zone}>
                                {tz.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="output-group">
                    <label className="output-label">转换结果</label>
                    <div className="tool-output">{getConvertedTime()}</div>
                </div>
            </div>
        </div>
    );
};

export default TimezoneConverter;
